import type { IDashboardWidgetInterface } from "app/components/widget/utils/DashboardWidgetsInterfaces-v2";
import { minVisitsAbbrFilter } from "app/filters/ngFilters";
import type { FC } from "react";

export const SingleMetricSearchesTemplateV2: FC<IDashboardWidgetInterface> = (props) => {
    const { widget, data } = props;
    return (
        <div>
            <div className="data">
                <div className="large-single-number u-blueMediumMedium gt-vlarge-screen lt-vlarge-screen">
                    {minVisitsAbbrFilter()(data.Volume)}
                </div>
            </div>
        </div>
    );
};
